<template>
    <div class="user-basic background-supplement-no-title-layout">
        <div class="layout-content" v-if="haveStudentInfo">
            <div class="register-basic" v-loading="loading">
                <div class="register-basic-head">
                    <span class="title">头像：</span>
                    <app-upload-avatar @change="changeAvatar" :img-url="avatar"></app-upload-avatar>
                </div>
                <div class="register-basic-name">
                    <span class="title">姓名：</span>
                    <span style="color: #333;"> {{ studentName }} </span>
                    <label>请联系管理员修改</label>
                </div>
                <div class="register-basic-sex">
                    <span class="title">性别：</span>
                    <el-radio-group v-model="sex">
                        <el-radio class="radio" :label="1" style="margin-right: 10px;">男</el-radio>
                        <el-radio class="radio" :label="2">女</el-radio>
                    </el-radio-group>
                </div>
                <div class="register-basic-grade">
                    <span class="title">年级：</span>
                    <el-select v-model="myGrade" placeholder="请选择">
                        <el-option :label="item" :value="index" v-for="(item, index) in grades" :key="index"></el-option>
                    </el-select>
                </div>
                <div class="register-basic-area">
                    <span class="title">地区：</span>
                    <app-select-area :locale="locale" @changeOrigin="handleChangeLocale"></app-select-area>
                </div>
                <div class="register-basic-school">
                    <span class="title">学校：</span>
                    <input v-model="mySchool" type="text" style="outline:none" placeholder="请填写" />
                </div>
                <el-button type="primary" class="dialog-btn-common btn-sure" style="margin-left: 58px" @click="submitInfo">确认</el-button>
            </div>
        </div>
        <div class="layout-content success" v-else>
            <div class="success-notice">
                <img src="../../../assets/images/common/log_cuowu_big.png"> 未绑定
            </div>
            <p>您还未绑定孩子，无法查看孩子的个人信息</p>
            <p>请联系管理人员，完成绑定操作</p>
        </div>
    </div>
</template>

<script>
import Enums from '@/constants/enum';
import { mapActions } from 'vuex';
import AppSelectArea from './AppSelectArea.vue';
import AppUploadAvatar from './AppUploadAvatar.vue';
import _ from 'lodash';
import teacherAvatar from '../../../../static/teacher-avatar.png';
export default {
    components: { AppSelectArea, AppUploadAvatar },
    data() {
        return {
            flag: true,
            loading: true,
            sex: 1,
            mySchool: '',
            myGrade: null,
            curGrade: null,
            grades: Enums.Grade2,
            studentName: '',
            locale: '',
            haveStudentInfo: true,
            avatar: teacherAvatar
        };
    },
    beforeMount() {
        let studentInfo = this.$route.query.studentInfo;
        if (studentInfo !== undefined) {
            this.haveStudentInfo = studentInfo;
        } else {
            this.loading = false;
            this.USER_GET_PROFILE().then(basicInfo => {
                this.haveStudentInfo = true;
                this.studentName = basicInfo.name;
                this.mySchool = basicInfo.schoolName;
                this.myGrade = Enums.Grade[basicInfo.grade];
                this.curGrade = basicInfo.grade;
                this.avatar = basicInfo.avatar || this.avatar;
                this.sex = basicInfo.sex ? basicInfo.sex : 1;
                this.locale = basicInfo.locale ? basicInfo.locale : '';
            }).catch(err => {
                if (err.code === 1102) { // 没有学生信息
                    this.haveStudentInfo = false;
                } else {
                    this.$handleError(err.msg);
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    methods: {
        ...mapActions(['USER_GET_PROFILE', 'USER_SET_BASICINFO']),
        changeAvatar(value) {
            this.avatar = value;
        },
        submitInfo() {
            if (this.flag) {
                this.flag = false;
                let enumGrade = Enums.Grade;
                let firstGrade = this.myGrade;
                let firstGradeValue = _.findKey(enumGrade, item => item === firstGrade);
                if (!this.locale) {
                    this.$message.warning('请选择地区');
                    return;
                }
                if (!this.mySchool) {
                    this.$message.warning('请填写学校名');
                    return;
                }
                if (this.myGrade === Enums.Grade[this.curGrade]) {
                    this.USER_SET_BASICINFO({
                        avatar: this.avatar,
                        sex: this.sex,
                        grade: firstGradeValue,
                        locale: this.locale,
                        schoolName: this.mySchool
                    })
                        .then(() => {
                            this.$message.info('修改成功');
                        })
                        .catch(err => {
                            this.$message.error(err.msg);
                        }).finally(() => {
                            this.flag = true;
                        });
                } else {
                    this.USER_SET_BASICINFO({
                        avatar: this.avatar,
                        sex: this.sex,
                        grade: this.myGrade,
                        locale: this.locale,
                        schoolName: this.mySchool
                    })
                        .then(() => {
                            this.$message.info('修改成功');
                        })
                        .catch(err => {
                            this.$message.error(err.msg);
                        }).finally(() => {
                            this.flag = true;
                        });
                }
            }
        },
        handleChangeLocale(localeStr) {
            this.locale = localeStr;
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.register-basic {
    padding-left: 70px;
    margin-top: 70px;

    .register-basic-head {
        height: 100px;
        line-height: 100px;
        margin-bottom: 20px;

        .cur-avatar {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            display: inline-block;
            margin-right: 10px;
            vertical-align: middle;
        }

        label {
            font-size: 12px;
            color: #b1b1b1;
        }
    }

    .register-basic-name {
        margin-bottom: 20px;

        label {
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #b1b1b1;
            margin-left: 20px;
        }
    }

    .register-basic-sex,
    .register-basic-grade,
    .register-basic-area {
        margin-bottom: 20px;
    }

    .register-basic-school {
        margin-bottom: 20px;

        input {
            width: 310px;
            height: 36px;
            border-radius: 2px;
            border: 1px solid #e7e7e7;
            padding-left: 10px;
            font-size: 14px;
            color: #333;
        }

        input::-webkit-input-placeholder {
            color: #b1b1b1;
        }

        input:focus {
            border: 1px solid #eb5645;
        }
    }

    .title {
        width: 45px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        margin-right: 10px;
        font-size: 14px;
        color: #333;
    }

    .next {
        margin-left: 60px;
        margin-top: 10px;
        margin-bottom: 100px;
        width: 100px;
        border-radius: 2px;
        font-size: 16px;
        padding: 11px;
    }
}

.success {
    width: 100%;
    background-color: #fff;
    padding-top: 188px;

    .success-notice {
        height: 50px;
        width: 300px;
        margin: 0 auto;
        margin-bottom: 20px;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        color: #e55b45;

        img {
            width: 50px;
            height: 50px;
            vertical-align: middle;
            margin-right: 20px;
        }
    }

    p {
        width: 330px;
        margin: 0 auto;
        text-align: center;
        height: 20px;
        line-height: 20px;
        margin-bottom: 5px;
        font-size: 14px;
        color: #4d4d4d;
    }
}

.app-region {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/UserBasic.vue